import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import LiveStatus from "@/components/site/LiveStatus";

// User's number from profile: 0086 18367978727
const PHONE = "8618367978727";
const PRESET_MSG = "Hi Emporia World, I'd like to discuss a sourcing/shipping requirement.";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const link = `https://wa.me/${PHONE}?text=${encodeURIComponent(PRESET_MSG)}`;

  return (
    <div
      data-testid="whatsapp-floating"
      className={`fixed left-4 sm:left-6 bottom-4 sm:bottom-6 z-40 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {open && (
        <div
          className="mb-3 w-[260px] bg-white border border-ink-100 shadow-[0_24px_60px_-15px_rgba(16,24,40,0.25)] p-4 relative"
          data-testid="whatsapp-popup"
        >
          <button
            onClick={() => setOpen(false)}
            aria-label="Close"
            className="absolute top-2 right-2 text-ink-500 hover:text-ink-900"
          >
            <X className="w-4 h-4" />
          </button>
          <LiveStatus variant="compact" className="text-ink-900" />
          <p className="mt-3 font-heading font-bold text-ink-900 text-[15px] leading-tight">
            Talk to a sourcing rep on WhatsApp
          </p>
          <p className="mt-1.5 text-ink-500 text-xs leading-relaxed">
            Reply within ~30 minutes during business hours (Mon–Sat, 09:00–17:00 CST).
          </p>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-open-chat"
            className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1eb858] text-white px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={2} />
            Open WhatsApp
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle"
        aria-label="Chat on WhatsApp"
        className="group relative w-14 h-14 sm:w-[60px] sm:h-[60px] rounded-full bg-[#25D366] hover:bg-[#1eb858] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] flex items-center justify-center transition-all duration-300 hover:scale-110"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" aria-hidden />
        <MessageCircle className="relative w-6 h-6 sm:w-7 sm:h-7" strokeWidth={1.8} />
      </button>
    </div>
  );
}
